import React from "react";
import { Box, Chip, Link, Typography } from "@mui/material";
import { humanizeSiigoMessage, siigoErrorCodeLabel } from "./siigoHelpers";

/**
 * Renderiza un único error de Siigo (Code + Message + Params + Detail) dentro del
 * modal de errores, resaltando el código y el mensaje de forma amigable.
 */
export default function SiigoErrorItem({ error }) {
  const humanMessage = humanizeSiigoMessage(error.message);

  return (
    <Box
      sx={{
        border: "1px solid #ffcdd2",
        borderLeft: "4px solid #b71c1c",
        borderRadius: "8px",
        backgroundColor: "#fff5f5",
        p: 2,
        mb: 1.5,
      }}
    >
      <Box display="flex" alignItems="center" gap={1} flexWrap="wrap" mb={1}>
        {error.code && (
          <Chip
            label={error.code}
            size="small"
            sx={{ backgroundColor: "#b71c1c", color: "#fff", fontFamily: "monospace" }}
          />
        )}
        <Typography variant="subtitle2" fontWeight={700} color="#b71c1c">
          {siigoErrorCodeLabel(error.code)}
        </Typography>
      </Box>

      <Typography variant="body1" fontWeight={600} gutterBottom>
        {humanMessage}
      </Typography>

      {error.message && error.message !== humanMessage && (
        <Typography variant="caption" color="text.secondary" display="block">
          Mensaje original: {error.message}
        </Typography>
      )}

      {error.params.length > 0 && (
        <Typography variant="caption" color="text.secondary" display="block" mt={0.5}>
          Campo relacionado: <code>{error.params.join(", ")}</code>
        </Typography>
      )}

      {error.detail && /^https?:\/\//.test(error.detail) && (
        <Link
          href={error.detail}
          target="_blank"
          rel="noopener noreferrer"
          variant="caption"
          sx={{ display: "block", mt: 0.5 }}
        >
          Ver documentación del error
        </Link>
      )}
    </Box>
  );
}
